const styles = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: '4px',
    marginBottom: 8,
    boxShadow: `0px 0px 4px ${theme.radioDisabledText}`,
    padding: 14,
    fontSize: theme.textFontSize,
  },
  locationName: {
    color: theme.dispatchPanelLabelValueColor,
    fontWeight: 500,
    textTransform: 'uppercase',
    wordWrap: 'break-word',
  },
  equipContainer:{
    display: "flex",
    flexWrap: "wrap"
  },
  equipmentLabel: {
    color: theme.iconColor,
    fontWeight: 400,
  },
  equipmentValue: {
    color: theme.dispatchPanelLabelValueColor,
    fontWeight: 500,
    marginRight: 6,
    marginLeft: 6,
  },
  highlightedCard: {
    border: `2px solid ${theme.HeaderSelectedText}`,
    boxShadow: "0 14px 28px rgba(0,0,0,0.25)",
  },
  cardContainer: {
    maxWidth: '80%',
  },
  equipContainer:{
    display: "flex",
    flexWrap: "wrap"
  },
  divider: {
    borderLeft: `1px solid ${theme.AppBGColor}`,
    paddingLeft: 6
  }
});

export default styles;
